var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":_vm.title,"showBack":true}}),(_vm.StatementUrl!='')?_c('iframe',{staticStyle:{"overflow":"auto"},attrs:{"src":_vm.StatementUrl,"width":"100%","height":"900px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }